import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { updateProduct } from "../store/action";


function ProductEdit({ item }) {
    const categories = useSelector((state) => state.categoryReducer.categories)
    const dispatch = useDispatch()
    const [editForm, setEditForm] = useState(
        {
            name: item.name,
            description: item.description,
            price: item.price,
            mainImg: item.mainImg,
            CategoryId: item.CategoryId,
            images: item.Images.map(e => {return e.imgUrl})
        }
    )

    const handleChange = (e) => {
        const { value, name } = e.target
        const input = {
            ...editForm,
            [name]: value
        }
        setEditForm(input)
    }

    const changeImageHandler = (e, index) => {
        let newImages = [...editForm.images]
        newImages[index] = e.target.value

        console.log(newImages, "<<<new Images")

        setEditForm({
            ...editForm,
            images: newImages
        })
    }


    const addImageHandler = () => {
        setEditForm({
            ...editForm,
            images: [...editForm.images, '']
        })
    }

    const removeImageHandler = (e, i) => {
        let newForm = editForm.images.map(f => {
            return f
        })

        newForm.splice(i, 1)
        setEditForm({
            ...editForm,
            images: newForm
        })
    }

    const cancelEditHandler = () => {
        setEditForm(
            {
                name: item.name,
                description: item.description,
                price: item.price,
                mainImg: item.mainImg,
                CategoryId: item.CategoryId,
                images: item.Images.map(e => {return e.imgUrl})
            }
        )
    }

    const updateProductHandler = (e) => {
        console.log(editForm, "<<<form update")
        dispatch(updateProduct(e.target.value, editForm))
    }

    return (
        <section>
            <button className="btn btn-primary px-3 m-2" value={item.id} data-toggle="modal" data-target={`#updateModal${item.id}`}>Edit</button>

            <div className="modal fade" id={`updateModal${item.id}`} tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Update Product Details</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row mb-3">
                                <div className="col-3">
                                    <label>Name</label>
                                </div>
                                <div className="col">
                                    <input type="text" onChange={handleChange} className="form-control" name="name" value={editForm.name} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-3">
                                    <label>Description</label>
                                </div>
                                <div className="col">
                                    <input type="text" onChange={handleChange} className="form-control" name="description" value={editForm.description} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-3">
                                    <label>Price</label>
                                </div>
                                <div className="col">
                                    <input type="number" onChange={handleChange} className="form-control" name="price" value={editForm.price} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-3">
                                    <label>Image URL</label>
                                </div>
                                <div className="col">
                                    <input type="text" onChange={handleChange} className="form-control" name="mainImg" value={editForm.mainImg} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-3">
                                    <label>Category</label>
                                </div>
                                <div className="col">
                                    <select onChange={handleChange} defaultValue={editForm.CategoryId} className="form-control" name="CategoryId">
                                        <option value="DEFAULT" disabled>Choose one...</option>
                                        {categories.map(c => {
                                            return (<option key={c.id} value={c.id}>{c.name}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                            {editForm.images.map((f, index) => {
                                return (
                                    <div className="row mb-3" key={index}>
                                        <div className="col-3">
                                            <label>Images</label>
                                        </div>
                                        <div className="col">
                                            <input onChange={(e) => changeImageHandler(e, index)} type="text" value={f} className="form-control" />
                                        </div>
                                        <button className="btn btn-danger" onClick={(e) => { removeImageHandler(e, index) }}>&times;</button>
                                    </div>
                                )
                            })}

                            <button className="btn btn-outline-primary" onClick={addImageHandler}>Add More Image</button>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={cancelEditHandler}>Cancel</button>
                            <button type="button" className="btn btn-primary" onClick={updateProductHandler} value={item.id}>Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProductEdit